module.exports = __webpack_public_path__ + "static/img/about-banenr.56b00b62.png";